import "@/styles/szadmin.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail } from "lucide-react";

const AdminForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/forgot-password`,
        { email }
      );

      if (response.data.success) {
        setEmailSent(true);
        toast.success("Password reset link sent to your email");
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      // Still show success message for security (prevent email enumeration)
      setEmailSent(true);
      toast.success("If that email exists, a password reset link has been sent");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="sz-root relative flex h-dvh w-full items-center justify-center overflow-hidden p-6"
      style={{ background: "#0C1120" }}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(640px 480px at 78% 16%, rgba(120,40,124,.5), transparent 60%), radial-gradient(560px 460px at 18% 92%, rgba(40,192,208,.28), transparent 60%)",
        }}
      />

      <div
        className="sz-fade relative w-full max-w-[420px] rounded-[22px] bg-white px-[34px] py-9"
        style={{ boxShadow: "0 40px 90px -30px rgba(0,0,0,.6)" }}
      >
        {!emailSent ? (
          <form onSubmit={handleSubmit}>
            <div
              className="mb-5 flex h-[54px] w-[54px] items-center justify-center rounded-[15px]"
              style={{ background: "linear-gradient(135deg,#572B7C,#28C0D0)" }}
            >
              <Mail className="h-[28px] w-[28px] text-white" strokeWidth={2} />
            </div>
            <h1 className="sz-display mb-2 text-[23px] font-bold tracking-[-.4px]">
              Reset your password
            </h1>
            <p
              className="mb-6 text-[13.5px] leading-[1.6]"
              style={{ color: "#8A90A2" }}
            >
              Enter the email linked to your admin account and we'll send a
              reset link.
            </p>

            <label
              className="mb-[7px] block text-[12.5px] font-semibold"
              style={{ color: "#2B3142" }}
              htmlFor="forgot-email"
            >
              Email address
            </label>
            <input
              id="forgot-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@shootzu.com"
              className="sz-input mb-[18px] text-sm"
              style={{ padding: "12px 14px", borderRadius: "12px" }}
              required
            />

            <button
              type="submit"
              disabled={loading}
              className="sz-btn sz-btn-primary w-full"
              style={{ padding: "14px", borderRadius: "12px", fontSize: "14px" }}
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>

            <div className="mt-5 text-center">
              <Link
                to="/szadmin"
                className="text-[12.5px] font-semibold no-underline"
                style={{ color: "#572B7C" }}
              >
                ← Back to Admin Login
              </Link>
            </div>
          </form>
        ) : (
          <div>
            <div
              className="mb-5 flex h-[54px] w-[54px] items-center justify-center rounded-[15px]"
              style={{ background: "#DCFCE7", color: "#15803D" }}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 6 12 13 2 6M2 6h20v12H2z" />
                <path d="m9 14 2 2 4-4" />
              </svg>
            </div>
            <h1 className="sz-display mb-2 text-[23px] font-bold tracking-[-.4px]">
              Check your inbox
            </h1>
            <p
              className="mb-6 text-[13.5px] leading-[1.6]"
              style={{ color: "#8A90A2" }}
            >
              If an account exists for that email, a reset link is on its way.
              The link expires in 1 hour.
            </p>

            <button
              type="button"
              onClick={() => setEmailSent(false)}
              className="sz-btn sz-btn-outline mb-2.5 w-full"
              style={{
                padding: "13px",
                borderRadius: "12px",
                fontSize: "13.5px",
              }}
            >
              Try Another Email
            </button>

            <Link
              to="/szadmin"
              className="sz-btn sz-btn-primary block w-full text-center no-underline"
              style={{
                padding: "13px",
                borderRadius: "12px",
                fontSize: "13.5px",
              }}
            >
              Back to Admin Login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminForgotPassword;
